import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DropdownWrapper from '@components/common/dropdown_wrapper/main';

const CardActionsDropdown = ({
  cardEvent,
  handleReply,
  onDelete,
}) => {
  const { id } = cardEvent;
  const [closeDropdown, setCloseDropdown] = useState(false);

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(id);
  };

  const handleReplyAction = (handlerMethod) => {
    handlerMethod();
    setCloseDropdown(true);
  };

  const dropdownContents = () => (
    <ul className="event__dropdown-actions--menu">
      <li
        className="event-action reply-button"
        onClick={() => handleReplyAction(handleReply)}
        onKeyPress={() => handleReplyAction(handleReply)}
        role="button"
        tabIndex={0}
        type="button"
      >
        <span className="bff-comment" />
        {bfTranslate('Reply')}
      </li>
      <li
        className="event-action delete-button"
        onClick={handleDelete}
        onKeyPress={handleDelete}
        role="button"
        tabIndex={0}
        type="button"
      >
        <span className="bff-trash" />
        {bfTranslate('Delete')}
      </li>
    </ul>
  );

  return (
    <>
      <DropdownWrapper
        close={closeDropdown}
        closeCallback={() => setCloseDropdown(false)}
        cssTransitionClasses="fade-in-translate"
        dropdownContents={dropdownContents}
        openOnHover={false}
        wrapperClassnames="event__dropdown-actions"
      >
        <span className="bff-ellipsis" />
      </DropdownWrapper>
    </>
  );
};

CardActionsDropdown.propTypes = {
  cardEvent: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  handleReply: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CardActionsDropdown;
